export function canNotPreauth(client: any) {

  const stepsFlow = ['E25', 'E26', 'E27', 'E28','E29'];
  // const stepsFlowA = ['E25', 'E26', 'E27', 'E28','E29'];
  // const stepsFlowB = ['E22', 'E23', 'E24', 'E25', 'E27', 'E28','E29'];
// TODO: flowb
  // const flowType = client?.flowType || 'A';

  /* const statesForValidate = flowType === 'A' ? stepsFlowA : stepsFlowB; */

  // if (statesForValidate.includes(client.step)) {
  if (stepsFlow.includes(client.step)) {
    /* const payment = flowType === 'A'  ? client.E25.sectionPayment.deposit : client.E27.sectionInitialPayment.deposit; */
    if(client.E25){
      const payment = client.E25.sectionPayment.deposit
      return payment > 0;
    }


  }

  return false;

}
